import { getScrollTop, scrollTo } from '@theme/scroll-container';

const rootSelector = 'results-list[data-ir-load-more]';
const cacheKey = 'ir-collection-return';
let pending = false;

function locationKey() {
  const url = new URL(location.href);
  url.hash = '';
  return url.toString();
}

function savePosition(root) {
  const grid = root.querySelector('[ref="grid"]');
  const controls = root.querySelector('[data-ir-controls]');
  if (!grid || !controls) return;
  try {
    sessionStorage.setItem(cacheKey, JSON.stringify({ url: locationKey(), time: Date.now(), grid: grid.innerHTML, controls: controls.outerHTML, top: getScrollTop() }));
  } catch {}
}

function restorePosition() {
  if (performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
  try {
    const saved = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
    if (!saved || saved.url !== locationKey() || Date.now() - saved.time > 1800000) return;
    const root = document.querySelector(rootSelector);
    const grid = root?.querySelector('[ref="grid"]');
    const controls = root?.querySelector('[data-ir-controls]');
    if (!grid || !controls) return;
    grid.innerHTML = saved.grid;
    controls.outerHTML = saved.controls;
    requestAnimationFrame(() => requestAnimationFrame(() => scrollTo({ top: saved.top, behavior: 'instant' })));
  } catch {}
}

document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;
  const root = event.target.closest(rootSelector);
  if (!root) return;
  const link = event.target.closest('a');
  if (link?.href.includes('/products/')) savePosition(root);
  const button = event.target.closest('[data-ir-next]');
  if (!button || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  if (pending) return;
  pending = true;
  const grid = root.querySelector('[ref="grid"]');
  const controls = root.querySelector('[data-ir-controls]');
  const label = button.textContent;
  const originalUrl = locationKey();
  button.setAttribute('aria-disabled', 'true');
  button.textContent = button.dataset.loading;
  grid?.setAttribute('aria-busy', 'true');
  try {
    const url = new URL(button.href);
    const current = new URL(location.href);
    if (current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
    url.searchParams.set('section_id', root.getAttribute('section-id'));
    const response = await fetch(url, { signal: AbortSignal.timeout(20000) });
    if (!response.ok) throw new Error('Unable to load collection');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const nextGrid = doc.querySelector('[ref="grid"]');
    const nextControls = doc.querySelector('[data-ir-controls]');
    if (!nextGrid || !nextControls) throw new Error('Missing collection');
    if (!grid?.isConnected || root.querySelector('[ref="grid"]') !== grid || locationKey() !== originalUrl) return;
    const existing = new Set([...grid.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId));
    const cards = [...nextGrid.querySelectorAll(':scope > [data-product-id]')].filter(card => !existing.has(card.dataset.productId));
    for (const card of cards) for (const img of card.querySelectorAll('img')) { img.loading = 'lazy'; img.removeAttribute('fetchpriority'); }
    grid.append(...cards);
    const nextLink = nextControls.querySelector('[data-ir-next]');
    if (nextLink) button.href = nextLink.href;
    else button.remove();
    const count = grid.querySelectorAll(':scope > [data-product-id]').length;
    const message = document.createElement('textarea');
    message.innerHTML = controls.dataset.countTemplate;
    controls.querySelector('[data-ir-progress]').textContent = message.value.replace('__COUNT__', count.toString());
    const firstLink = cards[0]?.querySelector('a');
    firstLink?.focus({ preventScroll: true });
  } catch {
    if (controls?.isConnected) controls.querySelector('[data-ir-progress]').textContent = button.dataset.error;
  } finally {
    pending = false;
    button.removeAttribute('aria-disabled');
    button.textContent = label;
    grid?.removeAttribute('aria-busy');
  }
});

window.addEventListener('pagehide', () => {
  const root = document.querySelector(rootSelector);
  if (root) savePosition(root);
});

restorePosition();
